import jnpf from '@/utils/jnpf'
import Cookies from 'js-cookie'
const TokenKey = 'jnpf_token'


export function getToken() {
  // return jnpf.storageGet('token')
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  // return jnpf.storageSet({ token })
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  // return jnpf.storageRemove('token')
  return Cookies.remove(TokenKey)
}

export function getLock() {
  return jnpf.storageGet('lock')
}

export function setLock(lock) {
  return jnpf.storageSet({ lock })
}
export function removeLock() {
  return jnpf.storageRemove('lock')
}